<script>
import formatDay from "@utils/format-day";
import getISODay from "date-fns/getISODay";
import { Fancybox } from "@fancyapps/ui";
export default {
  props: {
    reservationItem: {
      type: Object,
      default: () => {
        return {
          "content": "本店使用法國進口armin寵物狗專用沐浴乳，溫和清香不刺激，皮膚病與敏感肌膚狗狗皆可使用。<br>本店洗澡全程溫控32度溫水清洗，讓狗狗有如做spa般享受整個洗澡過程。<br>本店使用法國進口armin寵物狗專用沐浴乳，溫和清香不刺激，皮膚病與敏感肌膚狗狗皆可使用。",
          "notice": "※ 目前暫無提供具攻擊性犬隻美容服務<br>※ 全身打結不剃毛恕無法提供服務，拆結過程易導致皮膚發炎<br>※ 全身嚴重跳蚤壁蝨／嚴重皮膚病恕無法提供服務，請先尋求獸醫治療",

        }
      }
    },
    storeItem: {
      type: Object,
      default: () => {
        return {
          "fullAddress": "新北市新莊區中正路542號",
          "storeType": "",
          "lat": 25.0542851,
          "lng": 121.5609319,
          "params": {
            "addressRestrictions": [
              {
                "city": "臺北市",
                "district": [
                  "中正區",
                  "中山區",
                  "大同區",
                  "松山區",
                  "萬華區",
                  "大安區",
                  "信義區",
                  "士林區"
                ]
              },
              {
                "city": "新北市",
                "district": [
                  "深坑區",
                  "板橋區",
                  "林口區",
                  "蘆洲區",
                  "三重區",
                  "新莊區",
                  "中和區",
                  "永和區",
                  "汐止區",
                  "新店區"
                ]
              }
            ]
          }
        }
      }
    }
  },
  data() {
    return {
      toDayDay: getISODay(new Date()),
      show: true,
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
  methods: {
    formatDay,
    formatPhonenumber(phonenumber = '') {
      const [number] = phonenumber.split('-');

      return number
        ? phonenumber
        : ''
    },
    openFancybox() {
      const imageList = this.storeItem.images.map(item => {
        return {
          src: item.path,
          thumb: item.path,
          caption: "",
        }
      });

      Fancybox.show(imageList, {
        mainClass: 'isStyleJtails',
        Toolbar: {
          display: [
            { id: "prev", position: "center" },
            { id: "counter", position: "center" },
            { id: "next", position: "center" },
            "close",
          ],
        },
      });

      Fancybox.getInstance().jumpTo(this.pageCount - 1);
    },
  }
}
</script>
<!-- section template -->
<template>
  <section :class="$style.itemSectionContentJtails" class="section">
    <div id="content" style="position: relative; top: -6rem"></div>
    <div
      v-if="reservationItem.content"
      class="mb-5"
    >
      <BaseSectionTitleJtails
        v-if="!$globalIsDingBeauty"
        class="itemSectionContentJtails__title"
        title="服務內容"
        title-class="text-primary-dark"
        sub-title="Service"
        :description="reservationItem.content"
      />
      <BaseSectionTitleSecondary
        v-else
        title="服務內容"
        class="itemSectionContentJtails__title"
        :description="reservationItem.content"
      />
    </div>

    <div
      v-if="reservationItem.notice"
      class="mb-5"
    >
      <div id="notice" style="position: relative; top: -6rem"></div>
      <BaseSectionTitleJtails
        v-if="!$globalIsDingBeauty"
        class="itemSectionContentJtails__title"
        title="注意事項"
        title-class="text-primary-dark"
        sub-title="Notice"
        :description="reservationItem.notice"
      />
      <BaseSectionTitleSecondary
        v-else
        title="注意事項"
        class="itemSectionContentJtails__title"
        :description="reservationItem.notice"
      />
    </div>

    <div id="address" style="position: relative; top: -6rem"></div>
    <template v-if="storeItem.storeType === 'home' && !!storeItem.params.addressRestrictions[0]">
      <BaseSectionTitleJtails
        v-if="!$globalIsDingBeauty"
        class="itemSectionContentJtails__title mb-3"
        title="服務範圍"
        title-class="text-primary-dark"
        sub-title="Location"
      />
      <BaseSectionTitleSecondary
        v-else
        title="服務範圍"
        class="itemSectionContentJtails__title mb-3"
        :description="reservationItem.notice"
      />
      <ul :class="$style.areaList">
        <li
          v-for="(areaItem, key, index) in storeItem.params.addressRestrictions"
          :key="index"
          class="areaList__item"
        >
          <span class="areaList__title">{{ areaItem.city }}</span>
          <span class="areaList__text">
            {{ areaItem.district.join(', ') }}
          </span>
        </li>
      </ul>
    </template>
    <template v-if="storeItem.storeType === 'store' && ( storeItem.fullAddress || (storeItem.lat && storeItem.lng) )">
      <BaseSectionTitleJtails
        v-if="!$globalIsDingBeauty"
        class="itemSectionContentJtails__title"
        title="服務地點"
        title-class="text-primary-dark"
        sub-title="Location"
      >
        <a
          slot="description"
          :href="`https://www.google.com.tw/maps/search/${ storeItem.fullAddress }`"
          target='_blank'
        >
          <span>{{ storeItem.title }}: </span>
          <span>{{ storeItem.fullAddress }}</span>
          <i class="far fa-external-link-alt fa-sm ml-1"></i>
        </a>
      </BaseSectionTitleJtails>
      <BaseSectionTitleSecondary
        v-else
        title="店家資訊"
        class="itemSectionContentJtails__title"
      />
      <div class="row">
        <div
          v-if="storeItem.lat && storeItem.lng"
          class="itemSectionContentJtails__googleMapBox"
          :class="$globalIsDingBeauty ? 'col-md-6' : 'col-12'"
        >
          <GmapMap
            :center="{ lat: storeItem.lat, lng: storeItem.lng }"
            :zoom="18"
            map-type-id="terrain"
            class="itemSectionContentJtails__googleMap"
          >
            <GmapMarker
              :position="{ lat: storeItem.lat, lng: storeItem.lng }"
              :icon="`${require('@assets/images/reservation/locate.png')}`"
            />
          </GmapMap>
        </div>
        <div v-if="$globalIsDingBeauty" class="col-md-6">
          <div class="fs-lg mb-2 mt-md-0 mt-3">{{ storeItem.title }}</div>
          <ul :class="[$style.metaList]" >
            <li
              v-if="!!formatPhonenumber(storeItem.phoneNumber)"
              class="metaList__item"
            >
              <a
                :href="`tel:${ formatPhonenumber(storeItem.phoneNumber) }`"
                class="metaList__link"
              >
                <i class="metaList__icon fontello fontello-phone fa-fw"></i>
                <span class="metaList__text">{{ formatPhonenumber(storeItem.phoneNumber) }}</span>
              </a>
            </li>
            <template v-if="!storeItem.storeType || storeItem.storeType === 'store'">
              <li
                v-if="!!storeItem.fullAddress"
                class="col-12 metaList__item"
              >
                <a
                  :href="`https://www.google.com.tw/maps/search/${ storeItem.fullAddress }`"
                  class="metaList__link"
                  target="_blank"
                >
                  <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                  <span class="metaList__text">{{ storeItem.fullAddress }}</span>
                </a>
              </li>
              <li
                v-if="!!storeItem.params.serviceTimeSetting[toDayDay].start && !!storeItem.params.serviceTimeSetting[toDayDay].end"
                class="metaList__item"
              >
                <el-popover
                  v-if="show"
                  placement="bottom-start"
                  :trigger="$globalBreakpoint === 'xs' || $globalBreakpoint === 'sm' || $globalBreakpoint === '2sm' || $globalBreakpoint === 'md' ? 'click' : 'hover'"
                  content=""
                >
                  <div
                    slot="reference"
                    class="metaList__link"
                  >
                    <i class="metaList__icon fontello fontello-info fa-fw"></i>
                    <span class="metaList__text">
                      <span>今日</span>
                      <span
                        v-if="!!storeItem.params.serviceTimeSetting[toDayDay].isOpen"
                        class="font-number"
                      >營業時間
                        {{
                          storeItem.params.serviceTimeSetting[toDayDay].start
                        }}-{{ storeItem.params.serviceTimeSetting[toDayDay].end }}</span>
                    <span v-else>不營業</span>
                    </span>
                    <i class="fontello fontello-down fa-sm metaList__textIcon ml-1"></i>
                  </div>
                  <div>
                    <ul :class="$style.dayList">
                      <li
                        v-for="(dayItem, key, index2) in storeItem.params.serviceTimeSetting"
                        :key="index2"
                        class="dayList__item"
                        :class="{ isActive: toDayDay.toString() === key }"
                      >
                        <span class="dayList__title">{{ formatDay(key) }}</span>
                        <span
                          v-if="!!dayItem.isOpen"
                          class="dayList__time"
                        >{{
                            storeItem.params.serviceTimeSetting[key].start
                          }}-{{ storeItem.params.serviceTimeSetting[key].end }}</span>
                        <span v-else>不營業</span>
                      </li>
                    </ul>
                  </div>
                </el-popover>
              </li>
            </template>
            <template v-if="storeItem.storeType === 'home'">
              <li
                v-if="!!storeItem.params.addressRestrictions[0]"
                class="metaList__item"
              >
                <el-popover
                  v-if="show"
                  placement="bottom-start"
                  :trigger="$globalBreakpoint === 'xs' || $globalBreakpoint === 'sm' || $globalBreakpoint === '2sm' || $globalBreakpoint === 'md' ? 'click' : 'hover'"
                  content=""
                >
                  <div
                    slot="reference"
                    class="metaList__link"
                  >
                    <i class="metaList__icon fontello fontello-locate fa-fw"></i>
                    <span class="metaList__text">
                      服務範圍 {{ addressRestrictionsText(storeItem) }}部分地區
                    </span>
                    <i class="fontello fontello-down fa-sm metaList__textIcon ml-1"></i>
                  </div>
                  <div>
                    <ul :class="$style.areaList">
                      <li
                        v-for="(areaItem, key, index2) in storeItem.params.addressRestrictions"
                        :key="index2"
                        class="areaList__item"
                        :class="{ isActive: toDayDay.toString() === key }"
                      >
                        <span class="areaList__title">{{ areaItem.city }}</span>
                        <span class="areaList__text">
                          {{ areaItem.district.join(', ') }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </el-popover>
              </li>
              <li
                class="col-12 metaList__item"
              >
                <div
                  class="metaList__link"
                >
                  <i class="metaList__icon fontello fontello-info fa-fw"></i>
                  <span class="metaList__text">
                    到府時段 {{ homeTimeList.join(' | ') }}
                  </span>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </template>
  </section>
</template>
<!-- section style -->
<style lang="scss" module>
.itemSectionContentJtails {
  :global {
    .itemSectionContentJtails {
      &__googleMap {
        height: 250px
      }

      &__googleMapBox {
        overflow: hidden;
      }
    }
  }
}

.areaList {
  @include list-unstyled;

  :global {
    .areaList {
      &__item {
        line-height: 1.75;

        &:not(:last-child) {
          margin-bottom: 0.5rem;
        }
      }

      &__title {
        display: block;
        font-family: $font-serif;
        font-size: 0.875rem;
        font-weight: 600;
        color: $color-primary-dark;
      }

      &__text {
        font-size: 0.875rem;
      }
    }
  }
}
.metaList {
  @include list-unstyled;

  min-height: 5.5rem;
  margin-bottom: 2.5rem;
  line-height: 1.5;

  @include max-md {
    min-height: auto;
  }

  :global {
    .metaList {
      &__item {
        margin-bottom: 1rem;
        padding-bottom: 1rem;
        letter-spacing: 0.1em;
        border-bottom: 1px solid $color-line-2;
      }

      &__icon {
        padding-top: 0.15rem;
        margin-right: 0.5rem;
        color: $color-gray-3;
      }

      &__link {
        @include link-unstyled;

        display: inline-flex;
        font-size: 0.875rem;
        color: $color-gray-3;

        &[href] {
          &:hover, &:focus {
            color: $color-primary;

            .metaList {
              &__icon {
                color: $color-primary;
              }
            }
          }
        }
      }

      &__textIcon {
        color: $color-gray-3;
        transform: scale(0.8) translateY(5px);
      }

      &__text {
        @include unstyled;
      }
    }
  }
}
.dayList {
  padding: 0.25rem 0;
  line-height: 2;

  @include list-unstyled;

  :global {
    .dayList {
      &__title {
        margin-right: 0.5rem;
        font-weight: 500;
      }

      &__time {
        font-family: $font-number;
        color: $color-gray-2;
      }

      &__item {
        padding: 0 0.5rem;

        &.isActive {
          color: $color-primary;

          .dayList {
            &__time {
              color: $color-primary;
            }
          }
        }
      }
    }
  }
}
</style>
